import AOS from "aos";
import "./src/styles/global.scss";
import { focusHandling } from "cruip-js-toolkit";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import * as React from 'react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import linkResolver from "./linkResolver";

// Suppress Gatsby "External link" warnings that only appear in local development
// These warnings occur when Gatsby's dev server hasn't fully built the page routing tree
// and mistakenly treats valid internal links as external ones. This is a known dev-only issue.
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (args[0]?.includes?.('External link') && args[0]?.includes?.('Link component')) {
      return; // Suppress this specific warning - it doesn't occur in staging/production
    }
    originalWarn.apply(console, args);
  };
}

export const wrapRootElement = ({ element }) => {
  AOS.init({
    once: true,
    disable: "phone",
    duration: 2000,
    easing: "ease-out-cubic",
  });
  document.querySelector("html").style.scrollBehavior = "auto";
  window.scroll({ top: 0 });
  document.querySelector("html").style.scrollBehavior = "";
  focusHandling("outline");
  // Calls conversion event for gtag
  // if (window.gtag) {
  //   window.gtag("event", "conversion", {
  //     send_to: "AW-443101053/jdvMCLaqqfIBEP3epNMB",
  //   });
  // }
  if (process.env.NODE_ENV === "production") {
    disableReactDevTools();
  }
  return <PrismicPreviewProvider repositoryConfigs={[
    {
      repositoryName: "encord",
      linkResolver:linkResolver,
    },
  ]}>{element}</PrismicPreviewProvider>;
};
